<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="物流信息"
      width="500px"
      top="5vh"
      @close="1===1">
    <div v-loading="loading" style="height: 70vh; margin: 0; width: 100%; overflow-y: scroll;">
      <div style="height: 30px; background-color: #D1E6F5; line-height: 30px;">
        大田物流单号：{{data.tmsno}}
      </div>
      <div style="height: 50px; line-height: 50px;">
        <span style="color: #1C1C1C;">当前状态：</span>
        <span v-if="data.scan[data.scan.length-1].flag === 'DEX'" style="color: #FF4040;">{{data.scan[data.scan.length-1].text}}</span>
        <span v-else style="color: #65AEFE;">{{data.scan[data.scan.length-1].text}}</span>
      </div>
      <el-timeline style="margin: 10px 0 20px -30px;">
        <el-timeline-item
            v-for="(item, index) in data.scan"
            :key="index"
            :timestamp="item.time"
            :color="item.flag === 'DEX' ? '#FF4040' : (index === data.scan.length-1 ? '#65AEFE' : '')">
          <span v-if="item.flag === 'DEX'" style="color: #FF4040;">{{item.text}}</span>
          <span v-else-if="index === data.scan.length-1" style="color: #65AEFE;">{{item.text}}</span>
          <span v-else>{{item.text}}</span>
        </el-timeline-item>
      </el-timeline>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "LogisticsDetails",
    data() {
      return {
        dialogVisible: false,
        loading: false,
        data: {
          tmsno: "",
          scan: [{}],
        },
      };
    },
    methods: {
      open(billNO) {
        console.log(billNO);
        this.dialogVisible = true;
        this.getData(billNO);
      },
      getData(billNO) {
        this.loading = true;
        this.$http
          .get("basic",`dtw/${billNO}`)
          .then(resp => {
            console.log(resp);
            this.loading = false;
            if (resp.status === 1) {
              if (resp.data.result === "1") {
                this.data = resp.data.rows[0];
              } else {
                this.$message.error("物流接口返回失败");
              }
            } else {
              this.$message.error("查询失败，未查到物流信息");
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error("查询失败");
          });
      },
    },
  };
</script>
<style scoped>
</style>